import { useRouter, useRoute } from 'vue-router'

export default () => {
  const route = useRoute()
  const router = useRouter()
  return (code = 404, message = '') => {
    router.push({
      name: '404',
      params: {
        pathMatch: route.path.substring(1).split('/'),
        message: message,
        code: code,
      },
      query: route.query,
      hash: route.hash,
      replace: true,
    })
  }
}
